<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
    fill="none"
    aria-labelledby="refresh-icon-title refresh-icon-desc"
    role="img"
>
    <title id="refresh-icon-title">Refresh icon</title>
    <desc id="refresh-icon-desc">An icon depicting a refresh or reload action.</desc>
    <path
        d="M14.7046 5.29183C13.4962 4.0835 11.8379 3.3335 9.99622 3.3335C6.31289 3.3335 3.33789 6.31683 3.33789 10.0002C3.33789 13.6835 6.31289 16.6668 9.99622 16.6668C13.1046 16.6668 15.6962 14.5418 16.4379 11.6668H14.7046C14.0212 13.6085 12.1712 15.0002 9.99622 15.0002C7.23789 15.0002 4.99622 12.7585 4.99622 10.0002C4.99622 7.24183 7.23789 5.00016 9.99622 5.00016C11.3796 5.00016 12.6129 5.57516 13.5129 6.4835L10.8296 9.16683H16.6629V3.3335L14.7046 5.29183Z"
        fill="currentColor"
        class="fill"
    />
</svg>
